"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchLoadLeadSurveyCompletedWorker = watchLoadLeadSurveyCompletedWorker;
exports.default = watchLoadLeadSurveyCompleted;
const js_1 = __importDefault(require("@bugsnag/js"));
const effects_1 = require("redux-saga/effects");
const leadSurvey_1 = require("../../../slices/leadSurvey");
const fetchRelatedProperties_1 = __importDefault(require("../../multipleLeads/fetchers/fetchRelatedProperties"));
function* watchLoadLeadSurveyCompletedWorker(action) {
    try {
        const state = yield (0, effects_1.select)((state) => ({
            isLeadSurveyCompleted: state.leadSurvey.isLeadSurveyCompleted
        }));
        if (!state.isLeadSurveyCompleted) {
            return;
        }
        let propertyId;
        if (action.payload.terrainId) {
            propertyId = action.payload.terrainId;
        }
        else if (action.payload.projectId) {
            propertyId = action.payload.projectId;
        }
        else {
            return;
        }
        yield (0, effects_1.put)((0, leadSurvey_1.fetchLeadSurveyRelatedProperties)());
        const response = yield (0, effects_1.call)(fetchRelatedProperties_1.default, {
            email: action.payload.email,
            propertyId,
            type: 'terrains',
            limit: 4
        });
        yield (0, effects_1.put)((0, leadSurvey_1.fetchLeadSurveyRelatedPropertiesSuccess)(response));
    }
    catch (error) {
        js_1.default.notify(error);
        yield (0, effects_1.put)((0, leadSurvey_1.fetchLeadSurveyRelatedPropertiesFailure)('errors:unknownError'));
    }
}
function* watchLoadLeadSurveyCompleted() {
    yield (0, effects_1.takeLeading)([leadSurvey_1.loadLeadSurveySuccess, leadSurvey_1.submitLeadSurveySuccess], watchLoadLeadSurveyCompletedWorker);
}
//# sourceMappingURL=index.js.map